/*
  ARTSY FARTSY — Gallery wall builder (assets/gwb.js)

  Section: sections/gallery-wall-builder.liquid. The section writes a JSON
  config (rooms, wall colours, layouts in cm, frame colours, texts); this file
  does the rest.

  Units: every frame is stored in CENTIMETRES relative to the room's hanging
  point (room.cx / room.cy, in fractions of the room image). A room knows how
  many image pixels one centimetre is (room.ppc, at 2000 px width), so a
  50 x 70 poster is always drawn at its true size in every room.

  Data: posters come from the shop's own alternate views that render JSON
  (?view=gwb on collections, search and products), so sizes, frames and
  prices are the same as on the product page.

  Cart: the same convention as the ready-made walls (sections/gallery-wall):
  posters first, then frame + framing service with properties poster and
  _bundle_id taken from the poster's cart line, so the cart keeps them tied.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-gwb]');
  if (!root) return;
  var CFG;
  try { CFG = JSON.parse(root.querySelector('[data-gwb-config]').textContent); } catch (e) { return; }
  // Translations: the section sends CFG.i18n for every shop language but English.
  var I18N = CFG.i18n || null;
  var T = Object.assign({}, CFG.t || {}, (I18N && I18N.t) || {});
  if (I18N) {
    (CFG.rooms || []).forEach(function (r) { if (I18N.rooms && I18N.rooms[r.id]) r.name = I18N.rooms[r.id]; });
    (CFG.walls || []).forEach(function (w) { if (I18N.walls && I18N.walls[w.id]) w.name = I18N.walls[w.id]; });
    (CFG.layouts || []).forEach(function (l, i) { if (I18N.layouts && I18N.layouts[i]) l.label = I18N.layouts[i]; });
  }
  var app = root.querySelector('[data-gwb-app]');
  var ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var FB = 2.0;          // frame profile in cm (each side), as drawn
  var SNAP = 1.6;        // snap distance in cm
  var WALL_PPC = 2000 / 300; // colour walls: 300 cm wide
  var SIZES = ['21x30', '30x42', '50x70', '70x100'];
  var FRAME_ORDER = ['black', 'oak', 'white', 'brown', 'pink', 'green', 'blue', 'red', 'yellow'];
  var STORE_KEY = 'gwb-wall-v1';

  /* ------------------------------------------------------------ helpers */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svgEl(tag, attrs) {
    var n = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function uid() { return 's' + Math.random().toString(36).slice(2, 9); }
  function normSize(label) {
    var m = /(\d+)\s*[xX×]\s*(\d+)/.exec(label || '');
    return m ? (m[1] + 'x' + m[2]) : '';
  }
  function dims(s, o) {
    var p = s.split('x'); var w = +p[0], h = +p[1];
    return o === 'l' ? { w: h, h: w } : { w: w, h: h };
  }
  function sizeLabel(s, o) { var d = dims(s, o); return d.w + ' × ' + d.h + ' cm'; }
  function orient(ratio) { return ratio > 1.05 ? 'l' : (ratio < 0.95 ? 'p' : 'q'); }

  function fmtNumber(cents, decimals, thousands, decimal) {
    var v = (cents / 100).toFixed(decimals);
    var parts = v.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return decimals ? int + decimal + parts[1] : int;
  }
  function money(cents) {
    var f = CFG.moneyFormat || '';
    if (!f) return fmtNumber(cents, 2, '.', ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return fmtNumber(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNumber(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNumber(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNumber(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNumber(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmtNumber(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNumber(cents, 2, "'", '.');
        default: return fmtNumber(cents, 2, ',', '.');
      }
    });
  }
  var JSON_CACHE = {};
  function fetchJSON(url) {
    // same list page asked twice (preload + picker, or prefetch) -> one request
    if (JSON_CACHE[url]) return JSON_CACHE[url];
    var pr = fetchJSONRaw(url);
    JSON_CACHE[url] = pr;
    pr.catch(function () { delete JSON_CACHE[url]; });
    return pr;
  }
  function fetchJSONRaw(url) {
    // NB: no "Accept: application/json" header - Shopify then answers with its
    // own collection JSON instead of our ?view=gwb template.
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  /* ------------------------------------------------------------ statistik */

  // Anonym optælling i mockup-appen (se appens side "Billedvægsværktøj"):
  // kun hvad der sker, aldrig hvem. Fejler den, mærker kunden intet.
  var startet = false;
  // m = phone-sized screen (same breakpoint as the builder's own mobile layout), d = computer/tablet
  var DEVICE = (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) ? 'm' : 'd';
  function track(h, extra) {
    if (!CFG.track) return;
    try {
      var q = 'h=' + encodeURIComponent(h) + '&d=' + DEVICE;
      for (var k in (extra || {})) q += '&' + k + '=' + encodeURIComponent(extra[k]);
      fetch(CFG.track + '?' + q, { mode: 'no-cors', keepalive: true, credentials: 'omit', cache: 'no-store' }).catch(function () {});
    } catch (e) {}
  }
  function begyndt() { if (!startet) { startet = true; track('start'); } }

  /* ------------------------------------------------------------ state */

  var S = {
    room: { kind: 'photo', id: CFG.rooms[0].id },
    slots: [],
    frameAll: 'oak',
    service: false,
    step: 1,
    selected: null,
    missing: false
  };
  var PRODUCTS = {};   // handle -> product json

  function currentRoom() {
    if (S.room.kind === 'wall') {
      var w = CFG.walls.filter(function (x) { return x.id === S.room.id; })[0] || CFG.walls[0];
      return { kind: 'wall', id: w.id, name: w.name, color: w.color, ppc: WALL_PPC, cx: 0.5, cy: 0.40, top: 0.04, bottom: 0.82 };
    }
    var r = CFG.rooms.filter(function (x) { return x.id === S.room.id; })[0] || CFG.rooms[0];
    return { kind: 'photo', id: r.id, name: r.name, img: r.img, imgM: r.imgM, ppc: r.ppc, cx: r.cx, cy: r.cy, top: r.top || 0.04, bottom: r.bottom || 0.85 };
  }

  function slotById(id) { return S.slots.filter(function (s) { return s.id === id; })[0] || null; }

  function variantFor(slot) {
    if (!slot.product) return null;
    return slot.product.v.filter(function (v) { return normSize(v.size) === slot.s; })[0] || null;
  }
  function frameKeyFor(slot) { return slot.frame != null ? slot.frame : S.frameAll; }
  function frameFor(slot) {
    var v = variantFor(slot); var key = frameKeyFor(slot);
    if (!v || !key) return null;
    var f = v.f.filter(function (x) { return x[1] === key; })[0];
    return f ? { id: f[0], key: f[1], price: f[2], compare: f[3], border: f[4] } : null;
  }
  // For an empty slot we still want to preview the chosen frame colour.
  function previewFrameKey(slot) { return frameKeyFor(slot) || ''; }

  function posterFits(p, slot) {
    if (orient(p.ratio) !== slot.o) return false;
    return p.v.some(function (v) { return normSize(v.size) === slot.s; });
  }
  function onWall(handle, exceptId) {
    return S.slots.some(function (s) { return s.product && s.product.handle === handle && s.id !== exceptId; });
  }

  function applyLayout(layout) {
    var old = S.slots.filter(function (s) { return s.product; });
    S.slots = layout.slots.map(function (d) {
      return { id: uid(), s: d.s, o: d.o, x: d.x, y: d.y, product: null, frame: null };
    });
    // keep the posters the customer already picked where they still fit
    old.forEach(function (o) {
      var target = S.slots.filter(function (s) { return !s.product && posterFits(o.product, s); })[0];
      if (target) { target.product = o.product; target.frame = o.frame; }
    });
    S.selected = null;
    S.missing = false;
    fitToRoom();
  }

  // Keep the whole wall inside the room's hanging area (above the sofa,
  // below the ceiling) by moving it up or down - never by resizing it:
  // the frames must stay their true size.
  function fitToRoom() {
    if (!S.slots.length) return;
    var room = currentRoom();
    var px = room.ppc / 2000;              // fraction of the image per cm
    var top = Infinity, bot = -Infinity;
    S.slots.forEach(function (o) { var d = outerDims(o); top = Math.min(top, o.y - d.h / 2); bot = Math.max(bot, o.y + d.h / 2); });
    var yTop = room.cy + top * px, yBot = room.cy + bot * px;
    var shift = 0;
    if (yBot - yTop > room.bottom - room.top) shift = ((room.top + room.bottom) / 2 - (yTop + yBot) / 2);
    else if (yTop < room.top) shift = room.top - yTop;
    else if (yBot > room.bottom) shift = room.bottom - yBot;
    if (!shift) return;
    var cm = shift / px;
    S.slots.forEach(function (o) { o.y = Math.round((o.y + cm) * 2) / 2; });
  }

  /* ------------------------------------------------------------ persistence */

  function serialise() {
    return {
      r: (S.room.kind === 'wall' ? 'c:' : '') + S.room.id,
      f: S.frameAll || '',
      sv: S.service ? 1 : 0,
      s: S.slots.map(function (s) {
        return [s.s, s.o, Math.round(s.x * 10) / 10, Math.round(s.y * 10) / 10, s.product ? s.product.handle : '', s.frame == null ? null : s.frame];
      })
    };
  }
  function encode(obj) {
    var json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    return JSON.parse(decodeURIComponent(escape(atob(str))));
  }
  function save() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(serialise())); } catch (e) { /* private mode */ }
  }
  function restore(obj) {
    if (!obj || !obj.s) return Promise.resolve(false);
    var r = String(obj.r || '');
    if (r.indexOf('c:') === 0) S.room = { kind: 'wall', id: r.slice(2) };
    else if (r) S.room = { kind: 'photo', id: r };
    S.frameAll = obj.f || '';
    S.service = !!obj.sv;
    S.slots = obj.s.filter(function (a) { return SIZES.indexOf(a[0]) >= 0; }).map(function (a) {
      return { id: uid(), s: a[0], o: a[1] === 'l' ? 'l' : 'p', x: +a[2] || 0, y: +a[3] || 0, handle: a[4] || '', product: null, frame: a[5] == null ? null : a[5] };
    });
    var jobs = S.slots.filter(function (s) { return s.handle; }).map(function (s) {
      return loadProduct(s.handle).then(function (p) {
        if (p && posterFits(p, s) && !onWall(p.handle, s.id)) s.product = p;
      }).catch(function () {});
    });
    return Promise.all(jobs).then(function () { return true; });
  }
  function loadProduct(handle) {
    if (PRODUCTS[handle]) return Promise.resolve(PRODUCTS[handle]);
    return fetchJSON(ROUTE + 'products/' + encodeURIComponent(handle) + '?view=gwb').then(function (p) {
      PRODUCTS[p.handle] = p; return p;
    });
  }

  /* ------------------------------------------------------------ search index */

  // Searching through /search costs 0.6-0.8 s per page, and a landscape frame
  // needed up to 12 pages before enough posters turned up (measured 5 Oct
  // 2026: 3.4 s for "flower", on every word typed). Instead every poster is
  // fetched once as a lean list (templates/collection.gwb-index, 250 per
  // page, best-selling first) and searched right here in the browser.
  // Until the list is in, the old search through /search still answers.
  var INDEX = null, indexPr = null;
  var IDX_KEY = 'gwb-idx:' + ROUTE + ':' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || '');
  var IDX_TTL = 30 * 60 * 1000;
  // words in tags that are the shop's own bookkeeping, not what a poster shows
  var IDX_STOP = { best: 1, seller: 1, bestsellers: 1, resort: 1, br: 1, trending: 1, nonexclusive: 1, exclusive: 1, no: 1, tag: 1, flash: 1, posters: 1, poster: 1, color: 1, kunstplakater: 1 };

  function fold(str) {
    // lower case, accents off (é -> e) - but æ ø å ä ö stay, so "blå" doesn't find "black"
    return String(str || '').toLowerCase().replace(/[^\u0000-\u007f]/g, function (ch) {
      if ('æøåäöü'.indexOf(ch) >= 0) return ch;
      return ch.normalize ? ch.normalize('NFD').replace(/[̀-ͯ]/g, '') : ch;
    });
  }
  function words(str) { return fold(str).split(/[^a-z0-9æøåäöü]+/).filter(Boolean); }

  function leanPoster(x, rank) {
    var kw = words(x.k).filter(function (w) { return !IDX_STOP[w]; });
    return {
      lean: true, rank: rank,
      handle: x.h, title: x.t, vendor: x.a, ratio: x.r, thumb: x.i,
      v: (x.v || []).map(function (v) { return { size: v[0], price: v[1], compare: v[2] }; }),
      _t: words(x.t), _a: words(x.a), _k: kw, _full: fold(x.t + ' ' + x.a)
    };
  }

  function buildIndex(pages) {
    var out = [], seen = {};
    pages.forEach(function (d) {
      (d.products || []).forEach(function (x) {
        if (seen[x.h]) return; seen[x.h] = 1;
        out.push(leanPoster(x, out.length));
      });
    });
    return out;
  }

  function loadIndex() {
    if (indexPr) return indexPr;
    try {
      var c = JSON.parse(sessionStorage.getItem(IDX_KEY) || 'null');
      if (c && c.at > Date.now() - IDX_TTL && c.pages && c.pages.length) {
        INDEX = buildIndex(c.pages);
        indexPr = Promise.resolve(INDEX);
        return indexPr;
      }
    } catch (e) {}
    var url = function (n) { return ROUTE + 'collections/all?sort_by=best-selling&view=gwb-index&page=' + n; };
    indexPr = fetchJSONRaw(url(1)).then(function (first) {
      var n = first.pages || 1, jobs = [];
      for (var i = 2; i <= n; i++) jobs.push(fetchJSONRaw(url(i)));
      return Promise.all(jobs).then(function (rest) { return [first].concat(rest); });
    }).then(function (pages) {
      INDEX = buildIndex(pages);
      try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ at: Date.now(), pages: pages })); } catch (e) {}
      // a search typed while the list was on its way: answer it from the list now
      if (P.query && !picker.hidden) setSource(null, P.query);
      return INDEX;
    }).catch(function () { indexPr = null; return null; });   // the old search keeps working
    return indexPr;
  }

  function scoreWord(q, list, exact, prefix) {
    var best = 0;
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (w === q) return exact;
      if (best < prefix && w.lastIndexOf(q, 0) === 0) best = prefix;
      // the other way round, for endings: "blomster" finds "Blå Blomst", "flowers" finds "Flower"
      else if (best < prefix - 1 && w.length >= 4 && q.lastIndexOf(w, 0) === 0) best = prefix - 1;
    }
    return best;
  }

  function searchIndex(query) {
    var qs = words(query);
    if (!qs.length) return [];
    var phrase = fold(query).trim(), hits = [];
    INDEX.forEach(function (p) {
      var score = 0;
      for (var i = 0; i < qs.length; i++) {
        var q = qs[i];
        var s = Math.max(scoreWord(q, p._t, 6, 4), scoreWord(q, p._a, 5, 3), scoreWord(q, p._k, 2, 1));
        if (!s) return;               // every word must be found somewhere
        score += s;
      }
      if (qs.length > 1 && p._full.indexOf(phrase) >= 0) score += 4;
      hits.push({ p: p, s: score });
    });
    // best match first; equal matches in best-selling order
    hits.sort(function (a, b) { return (b.s - a.s) || (a.p.rank - b.p.rank); });
    return hits.map(function (h) { return h.p; });
  }

  /* ------------------------------------------------------------ DOM skeleton */

  app.innerHTML = '';
  var stageWrap = el('div', 'gwb__stagewrap');
  var stage = el('div', 'gwb__stage');
  var roomImg = el('img', 'gwb__room'); roomImg.alt = ''; roomImg.draggable = false;
  roomImg.decoding = 'async'; roomImg.setAttribute('fetchpriority', 'high');
  roomImg.sizes = '(max-width: 900px) 100vw, 900px';
  var wallBg = el('div', 'gwb__wall');
  var guides = el('div', 'gwb__guides');
  var framesLayer = el('div', 'gwb__frames');
  var hint = el('p', 'gwb__draghint', T.dragHint);
  stage.appendChild(wallBg); stage.appendChild(roomImg); stage.appendChild(framesLayer); stage.appendChild(guides);
  // "+ Add a frame" right on the wall, so nobody has to hunt for it.
  var addOnWall = el('button', 'gwb__addbtn', '+ ' + T.addFrame); addOnWall.type = 'button';
  addOnWall.addEventListener('click', function () {
    S.step = 3; paintPanel();
    var sel = body.querySelector('.gwb__addframe select');
    var box = body.querySelector('.gwb__addframe');
    if (box) {
      box.classList.add('is-flash');
      setTimeout(function () { box.classList.remove('is-flash'); }, 1400);
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (sel) sel.focus({ preventScroll: true });
  });
  stage.appendChild(addOnWall);
  stageWrap.appendChild(stage); stageWrap.appendChild(hint);

  var panel = el('div', 'gwb__panel');
  var steps = el('ol', 'gwb__steps');
  var body = el('div', 'gwb__body');
  var foot = el('div', 'gwb__foot');
  panel.appendChild(steps); panel.appendChild(body); panel.appendChild(foot);

  app.appendChild(stageWrap); app.appendChild(panel);

  var STEP_NAMES = [T.step1, T.step2, T.step3, T.step4];
  STEP_NAMES.forEach(function (name, i) {
    var li = el('li');
    var b = el('button', 'gwb__step');
    b.type = 'button';
    b.appendChild(el('span', 'gwb__stepnum', String(i + 1)));
    b.appendChild(el('span', 'gwb__steplabel', name));
    b.addEventListener('click', function () { goStep(i + 1); });
    li.appendChild(b); steps.appendChild(li);
  });

  // footer
  var summary = el('div', 'gwb__summary');
  var counts = el('span', 'gwb__counts');
  var totalLabel = el('span', 'gwb__totallabel', T.total);
  var totalBox = el('span', 'gwb__total');
  // row 1: "Total" ........ old price  new price
  // row 2: Posters: 3/3 · Frames: 3
  summary.appendChild(totalLabel); summary.appendChild(totalBox); summary.appendChild(counts);
  var addBtn = el('button', 'gwb__add', T.add); addBtn.type = 'button';
  var note = el('p', 'gwb__note'); note.hidden = true;
  var tools = el('div', 'gwb__tools');
  var shareBtn = el('button', 'gwb__link', T.share); shareBtn.type = 'button';
  var clearBtn = el('button', 'gwb__link', T.clear); clearBtn.type = 'button';
  tools.appendChild(shareBtn); tools.appendChild(clearBtn);
  foot.appendChild(summary); foot.appendChild(addBtn); foot.appendChild(note); foot.appendChild(tools);

  /* ------------------------------------------------------------ stage */

  var frameEls = {};

  function stageMetrics() {
    var room = currentRoom();
    var W = stage.clientWidth || 1;
    var px = W / 2000 * room.ppc;   // screen px per cm
    return { room: room, W: W, H: stage.clientHeight || W, px: px, ox: room.cx * W, oy: room.cy * (stage.clientHeight || W) };
  }

  function outerDims(slot) {
    var d = dims(slot.s, slot.o);
    var framed = !!previewFrameKey(slot) && (!slot.product || !!frameFor(slot));
    return { w: d.w + (framed ? FB * 2 : 0), h: d.h + (framed ? FB * 2 : 0), framed: framed, poster: d };
  }

  // small frames (most frames on a phone) only need the 360px image
  function artSrc(p, w) {
    var dpr = window.devicePixelRatio || 1;
    return (p.thumb && w && w * dpr <= 380) ? p.thumb : p.img;
  }

  function paintStage() {
    var room = currentRoom();
    if (room.kind === 'photo') {
      if (roomImg.getAttribute('src') !== room.img) {
        // smaller 1200px photo for phones; the browser picks via srcset
        if (room.imgM) roomImg.srcset = room.imgM + ' 1200w, ' + room.img + ' 2000w'; else roomImg.removeAttribute('srcset');
        roomImg.src = room.img;
      }
      roomImg.hidden = false; wallBg.hidden = true;
      stage.style.backgroundColor = '';
    } else {
      roomImg.hidden = true; wallBg.hidden = false;
      wallBg.style.setProperty('--gwb-wall', room.color);
    }
    var m = stageMetrics();
    var seen = {};
    S.slots.forEach(function (slot) {
      seen[slot.id] = true;
      var n = frameEls[slot.id];
      if (!n) { n = buildFrameEl(slot); frameEls[slot.id] = n; framesLayer.appendChild(n.box); }
      paintFrame(slot, n, m);
    });
    Object.keys(frameEls).forEach(function (id) {
      if (!seen[id]) { framesLayer.removeChild(frameEls[id].box); delete frameEls[id]; }
    });
  }

  function buildFrameEl(slot) {
    var box = el('div', 'gwb-f');
    box.setAttribute('role', 'button');
    box.tabIndex = 0;
    var art = el('div', 'gwb-f__art');
    var img = el('img', 'gwb-f__img'); img.alt = ''; img.draggable = false;
    var empty = el('span', 'gwb-f__empty');
    var plus = el('span', 'gwb-f__plus', '+');
    var lab = el('span', 'gwb-f__size');
    empty.appendChild(plus); empty.appendChild(lab);
    art.appendChild(img); art.appendChild(empty);
    box.appendChild(art);
    box.appendChild(el('span', 'gwb-f__glass'));
    // Remove this frame in one tap - without having to pick a poster first.
    var del = el('button', 'gwb-f__del', '×');
    del.type = 'button';
    del.setAttribute('aria-label', T.remove);
    del.title = T.remove;
    del.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    del.addEventListener('click', function (e) { e.stopPropagation(); removeSlot(slot.id); });
    box.appendChild(del);
    attachDrag(box, slot.id);
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); clickSlot(slot.id); }
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); removeSlot(slot.id); }
      var step = e.shiftKey ? 5 : 1; var s = slotById(slot.id); if (!s) return;
      var moved = true;
      if (e.key === 'ArrowLeft') s.x -= step; else if (e.key === 'ArrowRight') s.x += step;
      else if (e.key === 'ArrowUp') s.y -= step; else if (e.key === 'ArrowDown') s.y += step; else moved = false;
      if (moved) { e.preventDefault(); paintStage(); save(); }
    });
    return { box: box, art: art, img: img, empty: empty, lab: lab };
  }

  function paintFrame(slot, n, m) {
    var od = outerDims(slot);
    var w = od.w * m.px, h = od.h * m.px;
    var cx = m.ox + slot.x * m.px, cy = m.oy + slot.y * m.px;
    var b = n.box.style;
    b.width = w + 'px'; b.height = h + 'px';
    b.left = (cx - w / 2) + 'px'; b.top = (cy - h / 2) + 'px';
    var sh = Math.max(2, m.px * 1.1);
    b.boxShadow = '0 ' + (sh * 0.9).toFixed(1) + 'px ' + (sh * 1.8).toFixed(1) + 'px rgba(0,0,0,.24), 0 ' + (sh * 0.2).toFixed(1) + 'px ' + (sh * 0.4).toFixed(1) + 'px rgba(0,0,0,.18)';

    // frame
    var key = previewFrameKey(slot);
    var fr = slot.product ? frameFor(slot) : null;
    var t = (od.framed ? FB * m.px : 0);
    if (od.framed) {
      var border = fr ? fr.border : borderForKey(key, slot.s);
      var meta = CFG.frames[key] || { color: '#c09b6f' };
      b.borderStyle = 'solid'; b.borderWidth = t + 'px';
      if (border) {
        b.borderColor = 'transparent';
        b.borderImageSource = 'url("' + border + '")';
        b.borderImageSlice = '18'; b.borderImageRepeat = 'round'; b.borderImageWidth = t + 'px';
      } else {
        b.borderImageSource = 'none'; b.borderColor = meta.color;
      }
    } else {
      b.borderStyle = 'none'; b.borderWidth = '0'; b.borderImageSource = 'none';
    }

    // artwork
    if (slot.product) {
      var want = artSrc(slot.product, w);
      if (n.img.getAttribute('src') !== want && !(want === slot.product.thumb && n.img.getAttribute('src') === slot.product.img)) n.img.src = want;
      n.img.hidden = false; n.empty.hidden = true;
      n.box.setAttribute('aria-label', slot.product.title + ', ' + sizeLabel(slot.s, slot.o));
    } else {
      n.img.hidden = true; n.img.removeAttribute('src'); n.empty.hidden = false;
      n.lab.textContent = sizeLabel(slot.s, slot.o);
      n.box.setAttribute('aria-label', T.choosePoster + ', ' + sizeLabel(slot.s, slot.o));
    }
    n.box.classList.toggle('is-selected', S.selected === slot.id);
    n.box.classList.toggle('is-missing', S.missing && !slot.product);
    n.box.classList.toggle('is-unframed', !od.framed);
    // the size label must fit inside even a small frame on a phone
    n.lab.style.fontSize = Math.max(7, Math.min(14, m.px * 2.4, w * 0.1)) + 'px';
  }

  // A frame colour's border image, borrowed from any loaded poster that has it.
  var borderCache = {};
  function borderForKey(key, size) {
    var ck = key + '|' + size;
    if (borderCache[ck] !== undefined) return borderCache[ck];
    var found = '';
    for (var h in PRODUCTS) {
      var p = PRODUCTS[h];
      for (var i = 0; i < p.v.length && !found; i++) {
        var fs = p.v[i].f;
        for (var j = 0; j < fs.length; j++) {
          if (fs[j][1] === key && fs[j][4] && (normSize(p.v[i].size) === size || !found)) { found = fs[j][4]; if (normSize(p.v[i].size) === size) break; }
        }
      }
      if (found) break;
    }
    if (found) borderCache[ck] = found;
    return found;
  }

  /* ------------------------------------------------------------ drag & snap */

  function attachDrag(box, id) {
    var start = null;
    box.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      var s = slotById(id); if (!s) return;
      start = { x: e.clientX, y: e.clientY, sx: s.x, sy: s.y, moved: false };
      box.setPointerCapture(e.pointerId);
    });
    box.addEventListener('pointermove', function (e) {
      if (!start) return;
      var s = slotById(id); if (!s) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!start.moved && Math.abs(dx) + Math.abs(dy) < 5) return;
      if (!start.moved) { start.moved = true; box.classList.add('is-dragging'); S.selected = id; begyndt(); }
      var m = stageMetrics();
      var nx = start.sx + dx / m.px, ny = start.sy + dy / m.px;
      var snapped = snap(s, nx, ny);
      s.x = snapped.x; s.y = snapped.y;
      showGuides(snapped.gx, snapped.gy, m);
      paintStage();
    });
    function end(e) {
      if (!start) return;
      var wasMoved = start.moved; start = null;
      box.classList.remove('is-dragging');
      clearGuides();
      if (wasMoved) { save(); paintPanel(); }
      else clickSlot(id);
    }
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', function () { if (start) { start = null; box.classList.remove('is-dragging'); clearGuides(); } });
  }

  function snap(slot, x, y) {
    var od = outerDims(slot);
    var mine = { l: -od.w / 2, c: 0, r: od.w / 2, t: -od.h / 2, m: 0, b: od.h / 2 };
    var bestX = null, bestY = null;
    S.slots.forEach(function (o) {
      if (o.id === slot.id) return;
      var d = outerDims(o);
      var xs = [o.x - d.w / 2, o.x, o.x + d.w / 2];
      var ys = [o.y - d.h / 2, o.y, o.y + d.h / 2];
      ['l', 'c', 'r'].forEach(function (k) {
        xs.forEach(function (tx) {
          var dist = Math.abs((x + mine[k]) - tx);
          if (dist < SNAP && (!bestX || dist < bestX.d)) bestX = { d: dist, x: tx - mine[k], g: tx };
        });
      });
      ['t', 'm', 'b'].forEach(function (k) {
        ys.forEach(function (ty) {
          var dist = Math.abs((y + mine[k]) - ty);
          if (dist < SNAP && (!bestY || dist < bestY.d)) bestY = { d: dist, y: ty - mine[k], g: ty };
        });
      });
    });
    // also the room's centre line
    if (Math.abs(x) < SNAP && (!bestX || Math.abs(x) < bestX.d)) bestX = { d: Math.abs(x), x: 0, g: 0 };
    return {
      x: bestX ? bestX.x : Math.round(x * 2) / 2,
      y: bestY ? bestY.y : Math.round(y * 2) / 2,
      gx: bestX ? bestX.g : null,
      gy: bestY ? bestY.g : null
    };
  }
  function showGuides(gx, gy, m) {
    guides.innerHTML = '';
    if (gx != null) { var v = el('span', 'gwb__guide gwb__guide--v'); v.style.left = (m.ox + gx * m.px) + 'px'; guides.appendChild(v); }
    if (gy != null) { var h = el('span', 'gwb__guide gwb__guide--h'); h.style.top = (m.oy + gy * m.px) + 'px'; guides.appendChild(h); }
  }
  function clearGuides() { guides.innerHTML = ''; }

  stage.addEventListener('pointerdown', function (e) {
    if (e.target === stage || e.target === roomImg || e.target === wallBg || e.target === framesLayer) {
      if (S.selected) { S.selected = null; paintStage(); paintPanel(); }
    }
  });

  function clickSlot(id) {
    S.selected = id;
    var s = slotById(id);
    paintStage();
    if (s && !s.product) { openPicker(id); }
    if (S.step < 3) S.step = 3;
    paintPanel();
  }

  function removeSlot(id) {
    S.slots = S.slots.filter(function (s) { return s.id !== id; });
    if (S.selected === id) S.selected = null;
    render(); save();
  }

  /* ------------------------------------------------------------ panel */

  function goStep(n) { S.step = n; paintPanel(); panel.scrollIntoView && window.innerWidth < 900 && panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  function paintPanel() {
    [].forEach.call(steps.children, function (li, i) {
      li.firstChild.classList.toggle('is-active', S.step === i + 1);
      li.firstChild.setAttribute('aria-current', S.step === i + 1 ? 'step' : 'false');
    });
    body.innerHTML = '';
    if (S.selected && slotById(S.selected)) body.appendChild(slotEditor(slotById(S.selected)));
    if (S.step === 1) body.appendChild(stepRooms());
    if (S.step === 2) body.appendChild(stepLayouts());
    if (S.step === 3) body.appendChild(stepPosters());
    if (S.step === 4) body.appendChild(stepFrames());
    var nav = el('div', 'gwb__nav');
    if (S.step > 1) { var b = el('button', 'gwb__ghost', T.back); b.type = 'button'; b.addEventListener('click', function () { goStep(S.step - 1); }); nav.appendChild(b); }
    if (S.step < 4) { var nx = el('button', 'gwb__next', T.next); nx.type = 'button'; nx.addEventListener('click', function () { goStep(S.step + 1); }); nav.appendChild(nx); }
    body.appendChild(nav);
    paintFoot();
  }

  function stepRooms() {
    var wrap = el('div', 'gwb__section');
    wrap.appendChild(el('h2', 'gwb__h', T.rooms));
    var grid = el('div', 'gwb__rooms');
    CFG.rooms.forEach(function (r) {
      var b = el('button', 'gwb__roomopt'); b.type = 'button';
      var im = el('img'); im.src = r.thumb; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im); b.appendChild(el('span', null, r.name));
      if (S.room.kind === 'photo' && S.room.id === r.id) b.classList.add('is-active');
      b.addEventListener('click', function () { S.room = { kind: 'photo', id: r.id }; fitToRoom(); render(); save(); begyndt(); track('room', { r: r.id }); });
      grid.appendChild(b);
    });
    wrap.appendChild(grid);
    wrap.appendChild(el('h2', 'gwb__h', T.colours));
    var sw = el('div', 'gwb__walls');
    CFG.walls.forEach(function (w) {
      var b = el('button', 'gwb__wallopt'); b.type = 'button';
      b.style.setProperty('--c', w.color);
      b.title = w.name; b.setAttribute('aria-label', w.name);
      if (S.room.kind === 'wall' && S.room.id === w.id) b.classList.add('is-active');
      b.addEventListener('click', function () { S.room = { kind: 'wall', id: w.id }; fitToRoom(); render(); save(); begyndt(); track('room', { r: 'farve-' + w.id }); });
      sw.appendChild(b);
    });
    wrap.appendChild(sw);
    return wrap;
  }

  function layoutThumb(slots) {
    var minx = Infinity, miny = Infinity, maxx = -Infinity, maxy = -Infinity;
    slots.forEach(function (s) {
      var d = dims(s.s, s.o); var w = d.w + FB * 2, h = d.h + FB * 2;
      minx = Math.min(minx, s.x - w / 2); maxx = Math.max(maxx, s.x + w / 2);
      miny = Math.min(miny, s.y - h / 2); maxy = Math.max(maxy, s.y + h / 2);
    });
    var pad = 8;
    var svg = svgEl('svg', { viewBox: (minx - pad) + ' ' + (miny - pad) + ' ' + (maxx - minx + pad * 2) + ' ' + (maxy - miny + pad * 2), 'aria-hidden': 'true' });
    slots.forEach(function (s) {
      var d = dims(s.s, s.o); var w = d.w + FB * 2, h = d.h + FB * 2;
      svg.appendChild(svgEl('rect', { x: s.x - w / 2, y: s.y - h / 2, width: w, height: h, rx: 0.8 }));
    });
    return svg;
  }

  function stepLayouts() {
    var wrap = el('div', 'gwb__section');
    var grid = el('div', 'gwb__layouts');
    CFG.layouts.forEach(function (l) {
      var b = el('button', 'gwb__layoutopt'); b.type = 'button';
      b.appendChild(layoutThumb(l.slots));
      b.appendChild(el('span', null, (l.label || l.name) + ' · ' + l.slots.length));
      b.addEventListener('click', function () {
        applyLayout(l); S.step = 2; render(); save(); begyndt();
        track('layout', { r: String(l.name).toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 24) });
      });
      grid.appendChild(b);
    });
    wrap.appendChild(grid);
    wrap.appendChild(addFrameControl());
    return wrap;
  }

  function addFrameControl() {
    var box = el('div', 'gwb__addframe');
    box.appendChild(el('h2', 'gwb__h', T.addFrame));
    var row = el('div', 'gwb__row');
    var size = document.createElement('select'); size.className = 'gwb__select'; size.setAttribute('aria-label', T.size);
    SIZES.forEach(function (s) { var o = el('option', null, sizeLabel(s, 'p')); o.value = s; size.appendChild(o); });
    size.value = '30x42';
    var ori = document.createElement('select'); ori.className = 'gwb__select'; ori.setAttribute('aria-label', T.portrait + '/' + T.landscape);
    [['p', T.portrait], ['l', T.landscape]].forEach(function (a) { var o = el('option', null, a[1]); o.value = a[0]; ori.appendChild(o); });
    var b = el('button', 'gwb__next', '+'); b.type = 'button'; b.setAttribute('aria-label', T.addFrame);
    b.addEventListener('click', function () {
      var slot = { id: uid(), s: size.value, o: ori.value, x: 0, y: 0, product: null, frame: null };
      placeFree(slot);
      S.slots.push(slot); S.selected = slot.id; S.missing = false;
      render(); save(); begyndt();
      // Next natural step: choose the poster for the new frame. On a phone,
      // show the wall first so the customer sees where the frame went.
      if (window.innerWidth < 900) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { openPicker(slot.id); }, window.innerWidth < 900 ? 450 : 0);
    });
    row.appendChild(size); row.appendChild(ori); row.appendChild(b);
    box.appendChild(row);
    return box;
  }

  // Put a new frame where it can be seen: right of the wall, left of it,
  // under it or over it - the first spot that stays inside the room's
  // hanging area and doesn't cover another frame. (On a phone "right of the
  // wall" was often outside the picture, 27 Sep 2026.)
  function placeFree(slot) {
    if (!S.slots.length) { slot.x = 0; slot.y = 0; fitToRoom(); return; }
    var room = currentRoom();
    var f = room.ppc / 2000;                 // fraction of the picture per cm
    var od = outerDims(slot), G = 6;
    var L = Infinity, R = -Infinity, T = Infinity, B = -Infinity;
    S.slots.forEach(function (o) {
      var d = outerDims(o);
      L = Math.min(L, o.x - d.w / 2); R = Math.max(R, o.x + d.w / 2);
      T = Math.min(T, o.y - d.h / 2); B = Math.max(B, o.y + d.h / 2);
    });
    var midY = (T + B) / 2, midX = (L + R) / 2;
    var cands = [
      { x: R + G + od.w / 2, y: T + od.h / 2 },
      { x: L - G - od.w / 2, y: T + od.h / 2 },
      { x: R + G + od.w / 2, y: midY },
      { x: L - G - od.w / 2, y: midY },
      { x: midX, y: B + G + od.h / 2 },
      { x: midX, y: T - G - od.h / 2 }
    ];
    function inside(c) {
      var x0 = room.cx + (c.x - od.w / 2) * f, x1 = room.cx + (c.x + od.w / 2) * f;
      var y0 = room.cy + (c.y - od.h / 2) * f, y1 = room.cy + (c.y + od.h / 2) * f;
      return x0 >= 0.02 && x1 <= 0.98 && y0 >= room.top && y1 <= room.bottom;
    }
    function free(c) {
      return S.slots.every(function (o) {
        var d = outerDims(o);
        return Math.abs(o.x - c.x) >= (d.w + od.w) / 2 + 2 || Math.abs(o.y - c.y) >= (d.h + od.h) / 2 + 2;
      });
    }
    var pick = cands.filter(function (c) { return inside(c) && free(c); })[0] || cands.filter(free)[0] || cands[0];
    slot.x = Math.round(pick.x * 2) / 2; slot.y = Math.round(pick.y * 2) / 2;
  }

  function stepPosters() {
    var wrap = el('div', 'gwb__section');
    wrap.appendChild(el('p', 'gwb__hint', T.pickHint));
    var list = el('ul', 'gwb__slotlist');
    orderedSlots().forEach(function (s) {
      var li = el('li', 'gwb__slotrow');
      if (S.missing && !s.product) li.classList.add('is-missing');
      if (S.selected === s.id) li.classList.add('is-selected');
      var th = el('span', 'gwb__slotthumb');
      if (s.product) { var im = el('img'); im.src = s.product.thumb; im.alt = ''; th.appendChild(im); }
      else th.textContent = '+';
      var txt = el('span', 'gwb__slottxt');
      txt.appendChild(el('strong', null, s.product ? s.product.title : T.choosePoster));
      txt.appendChild(el('span', null, sizeLabel(s.s, s.o)));
      var btn = el('button', 'gwb__slotbtn'); btn.type = 'button';
      btn.appendChild(th); btn.appendChild(txt);
      btn.addEventListener('click', function () { S.selected = s.id; paintStage(); openPicker(s.id); paintPanel(); });
      li.appendChild(btn);
      var rm = el('button', 'gwb__slotdel', '×'); rm.type = 'button';
      rm.setAttribute('aria-label', T.remove + ' – ' + sizeLabel(s.s, s.o)); rm.title = T.remove;
      rm.addEventListener('click', function () { removeSlot(s.id); });
      li.appendChild(rm);
      list.appendChild(li);
    });
    wrap.appendChild(list);
    wrap.appendChild(addFrameControl());
    return wrap;
  }

  // Reading order: top to bottom, then left to right.
  function orderedSlots() {
    return S.slots.slice().sort(function (a, b) {
      if (Math.abs(a.y - b.y) > 15) return a.y - b.y;
      return a.x - b.x;
    });
  }

  function frameSwatch(key, active, onPick, disabledNote) {
    var b = el('button', 'gwb__swatch'); b.type = 'button';
    var meta = CFG.frames[key];
    var dot = el('span', 'gwb__swatchdot');
    if (meta) {
      dot.style.backgroundColor = meta.color;
      if (meta.photo) dot.style.backgroundImage = 'url("' + meta.photo + '")';
    } else dot.classList.add('is-none');
    b.appendChild(dot);
    b.appendChild(el('span', 'gwb__swatchlabel', meta ? meta.label : T.noFrame));
    if (active) b.classList.add('is-active');
    b.addEventListener('click', onPick);
    return b;
  }

  function stepFrames() {
    var wrap = el('div', 'gwb__section');
    wrap.appendChild(el('h2', 'gwb__h', T.frameAll));
    var sw = el('div', 'gwb__swatches');
    sw.appendChild(frameSwatch('', !S.frameAll, function () { S.frameAll = ''; S.slots.forEach(function (s) { s.frame = null; }); S.service = false; render(); save(); }));
    FRAME_ORDER.forEach(function (k) {
      if (!CFG.frames[k]) return;
      sw.appendChild(frameSwatch(k, S.frameAll === k, function () { S.frameAll = k; S.slots.forEach(function (s) { s.frame = null; }); render(); save(); }));
    });
    wrap.appendChild(sw);

    // which slots can't have the chosen colour in their size
    var lacking = S.slots.filter(function (s) { return s.product && frameKeyFor(s) && !frameFor(s); });
    if (lacking.length) {
      var p = el('p', 'gwb__warn', (CFG.frames[S.frameAll] ? CFG.frames[S.frameAll].label + ': ' : '') + T.notInSize + ' (' + lacking.map(function (s) { return sizeLabel(s.s, s.o); }).join(', ') + ')');
      wrap.appendChild(p);
    }

    var anyService = S.slots.some(function (s) { var v = variantFor(s); return v && v.s && frameFor(s); });
    if (anyService) {
      var lab = el('label', 'gwb__service');
      var cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = S.service;
      cb.addEventListener('change', function () { S.service = cb.checked; paintFoot(); save(); });
      var txt = el('span');
      txt.appendChild(el('strong', null, T.service));
      txt.appendChild(el('span', null, T.serviceInfo));
      lab.appendChild(cb); lab.appendChild(txt);
      wrap.appendChild(lab);
    }
    return wrap;
  }

  function slotEditor(slot) {
    var box = el('div', 'gwb__editor');
    var head = el('div', 'gwb__edhead');
    head.appendChild(el('strong', null, slot.product ? slot.product.title : T.choosePoster));
    var x = el('button', 'gwb__x', '×'); x.type = 'button'; x.setAttribute('aria-label', T.close);
    x.addEventListener('click', function () { S.selected = null; paintStage(); paintPanel(); });
    head.appendChild(x);
    box.appendChild(head);

    var row = el('div', 'gwb__row');
    var size = document.createElement('select'); size.className = 'gwb__select'; size.setAttribute('aria-label', T.size);
    SIZES.forEach(function (s) {
      var o = el('option', null, sizeLabel(s, slot.o));
      o.value = s;
      if (slot.product && !slot.product.v.some(function (v) { return normSize(v.size) === s; })) { o.disabled = true; o.textContent += ' – ' + T.notInSize; }
      else if (slot.product) {
        var v = slot.product.v.filter(function (v) { return normSize(v.size) === s; })[0];
        if (v) o.textContent += ' – ' + money(v.price);
      }
      size.appendChild(o);
    });
    size.value = slot.s;
    size.addEventListener('change', function () { slot.s = size.value; render(); save(); });
    row.appendChild(size);

    if (!slot.product) {
      var ori = document.createElement('select'); ori.className = 'gwb__select';
      [['p', T.portrait], ['l', T.landscape]].forEach(function (a) { var o = el('option', null, a[1]); o.value = a[0]; ori.appendChild(o); });
      ori.value = slot.o;
      ori.addEventListener('change', function () { slot.o = ori.value; render(); save(); });
      row.appendChild(ori);
    }
    box.appendChild(row);

    // frame for this one poster
    var fsel = document.createElement('select'); fsel.className = 'gwb__select'; fsel.setAttribute('aria-label', T.frame);
    var optAll = el('option', null, T.frame + ': ' + (S.frameAll && CFG.frames[S.frameAll] ? CFG.frames[S.frameAll].label : T.noFrame) + ' (' + T.yourWall.toLowerCase() + ')');
    optAll.value = '__wall'; fsel.appendChild(optAll);
    var none = el('option', null, T.noFrame); none.value = ''; fsel.appendChild(none);
    var v = variantFor(slot);
    FRAME_ORDER.forEach(function (k) {
      if (!CFG.frames[k]) return;
      var f = v ? v.f.filter(function (x) { return x[1] === k; })[0] : null;
      if (v && !f) return;
      var o = el('option', null, CFG.frames[k].label + (f ? ' – ' + money(f[2]) : ''));
      o.value = k; fsel.appendChild(o);
    });
    fsel.value = slot.frame == null ? '__wall' : slot.frame;
    fsel.addEventListener('change', function () { slot.frame = fsel.value === '__wall' ? null : fsel.value; render(); save(); });
    box.appendChild(fsel);

    var acts = el('div', 'gwb__row');
    var ch = el('button', 'gwb__ghost', slot.product ? T.replace : T.choosePoster); ch.type = 'button';
    ch.addEventListener('click', function () { openPicker(slot.id); });
    var rm = el('button', 'gwb__ghost gwb__ghost--danger', T.remove); rm.type = 'button';
    rm.addEventListener('click', function () { removeSlot(slot.id); });
    acts.appendChild(ch); acts.appendChild(rm);
    box.appendChild(acts);
    return box;
  }

  /* ------------------------------------------------------------ totals & cart */

  function lineTotal(s) {
    var v = variantFor(s); if (!v) return { t: 0, c: 0 };
    var f = frameFor(s);
    var t = v.price, c = (v.compare > v.price ? v.compare : v.price);
    if (f) { t += f.price; c += (f.compare > f.price ? f.compare : f.price); }
    if (f && S.service && v.s) { t += v.s[1]; c += v.s[1]; }
    return { t: t, c: c };
  }

  function paintFoot() {
    var filled = S.slots.filter(function (s) { return s.product; });
    var framed = filled.filter(function (s) { return frameFor(s); });
    var tot = 0, cmp = 0;
    filled.forEach(function (s) { var l = lineTotal(s); tot += l.t; cmp += l.c; });
    counts.textContent = T.posters + ': ' + filled.length + '/' + S.slots.length + '  ·  ' + T.frames + ': ' + framed.length;
    totalBox.innerHTML = '';
    if (cmp > tot) totalBox.appendChild(el('s', null, money(cmp)));
    totalBox.appendChild(el('strong', null, money(tot)));
    if (S.missing && S.slots.every(function (s) { return s.product; })) { S.missing = false; note.hidden = true; }
  }

  function post(items) {
    return fetch(ROUTE + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  addBtn.addEventListener('click', function () {
    note.hidden = true;
    if (!S.slots.length) { note.textContent = T.missing; note.hidden = false; goStep(2); return; }
    var empty = S.slots.filter(function (s) { return !s.product || !variantFor(s); });
    if (empty.length) {
      S.missing = true;
      note.textContent = T.missing; note.hidden = false;
      S.step = 3; render();
      return;
    }
    addBtn.disabled = true; addBtn.textContent = T.adding;
    var live = orderedSlots();
    var wallId = 'custom-' + Date.now().toString(36);
    post(live.map(function (s) { return { id: variantFor(s).id, quantity: 1, properties: { _wall: wallId, _d: DEVICE } }; }))
      .then(function (res) {
        var added = res.items || [];
        var addons = [];
        live.forEach(function (s, i) {
          var f = frameFor(s); if (!f) return;
          var v = variantFor(s);
          var line = added[i] || {};
          var posterTitle = line.title || s.product.title;
          var bundleId = line.sku || v.sku || '';
          addons.push({ id: f.id, quantity: 1, properties: { poster: posterTitle, _bundle_id: bundleId, _wall: wallId } });
          if (S.service && v.s) {
            addons.push({ id: v.s[0], quantity: 1, properties: { poster: posterTitle, frame: (CFG.frames[f.key] || {}).label || f.key, _bundle_id: bundleId, _wall: wallId } });
          }
        });
        return addons.length ? post(addons) : null;
      })
      .then(function () {
        track('cart', { n: live.length });
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.location.href = ROUTE + 'cart';
      })
      .catch(function () {
        addBtn.disabled = false; addBtn.textContent = T.add;
        note.textContent = T.error; note.hidden = false;
      });
  });

  shareBtn.addEventListener('click', function () {
    var url = location.origin + location.pathname + location.search + '#w=' + encode(serialise());
    try { history.replaceState(null, '', url); } catch (e) {}
    var done = function () { shareBtn.textContent = T.copied; setTimeout(function () { shareBtn.textContent = T.share; }, 2200); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
    else done();
  });
  clearBtn.addEventListener('click', function () {
    S.frameAll = 'oak'; S.service = false; S.step = 1; S.missing = false;
    applyLayout(CFG.layouts[3] || CFG.layouts[0]);
    S.slots.forEach(function (s) { s.product = null; });
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    render(); save();
  });

  /* ------------------------------------------------------------ poster picker */

  var picker = el('div', 'gwb-pick'); picker.hidden = true;
  picker.setAttribute('role', 'dialog'); picker.setAttribute('aria-modal', 'true');
  var pBox = el('div', 'gwb-pick__box');
  var pHead = el('div', 'gwb-pick__head');
  var pTitle = el('h2', 'gwb-pick__title');
  var pClose = el('button', 'gwb__x', '×'); pClose.type = 'button'; pClose.setAttribute('aria-label', T.close);
  var pRemove = el('button', 'gwb__link gwb-pick__remove', T.remove); pRemove.type = 'button';
  pRemove.addEventListener('click', function () { var id = P.slotId; closePicker(); if (id) removeSlot(id); });
  var pHeadR = el('div', 'gwb-pick__headr');
  pHeadR.appendChild(pRemove); pHeadR.appendChild(pClose);
  pHead.appendChild(pTitle); pHead.appendChild(pHeadR);
  var pTabs = el('div', 'gwb-pick__tabs');
  var pSearch = document.createElement('input'); pSearch.type = 'search'; pSearch.className = 'gwb-pick__search'; pSearch.placeholder = T.search;
  var pGrid = el('div', 'gwb-pick__grid');
  var pMore = el('button', 'gwb__ghost gwb-pick__more', T.loadMore); pMore.type = 'button';
  var pEmpty = el('p', 'gwb-pick__empty', T.noResults); pEmpty.hidden = true;
  pBox.appendChild(pHead); pBox.appendChild(pSearch); pBox.appendChild(pTabs); pBox.appendChild(pGrid); pBox.appendChild(pEmpty); pBox.appendChild(pMore);
  picker.appendChild(pBox);
  document.body.appendChild(picker);

  var P = { slotId: null, source: null, query: '', page: 0, pages: 1, items: [], loading: false, token: 0, local: false, shown: 0 };
  var LOCAL_PAGE = 48;   // posters shown per "show more" when searching the index

  CFG.sources.forEach(function (src) {
    var b = el('button', 'gwb-pick__tab', src.title); b.type = 'button';
    b.dataset.handle = src.handle;
    b.addEventListener('click', function () { pSearch.value = ''; setSource(src.handle, ''); });
    pTabs.appendChild(b);
  });
  // "Often bought together": Shopify's own recommendations for the posters
  // already on the wall (sections/gwb-recommendations renders them as data).
  var TOGETHER = '__together';
  var tTab = el('button', 'gwb-pick__tab', T.together || 'Often bought together'); tTab.type = 'button';
  tTab.dataset.handle = TOGETHER;
  tTab.addEventListener('click', function () { pSearch.value = ''; setSource(TOGETHER, ''); });
  pTabs.appendChild(tTab);
  var togetherKey = '';

  function openPicker(slotId) {
    var s = slotById(slotId); if (!s) return;
    loadIndex();
    P.slotId = slotId;
    pTitle.textContent = T.choosePoster + ' · ' + sizeLabel(s.s, s.o) + ' · ' + (s.o === 'l' ? T.landscape : T.portrait);
    picker.hidden = false;
    // the frame opens the picker on finger-up; the phone's click comes right
    // after and must not land on a poster that is now under the finger
    picker.style.pointerEvents = 'none';
    clearTimeout(P.guard); P.guard = setTimeout(function () { picker.style.pointerEvents = ''; }, 400);
    document.documentElement.classList.add('gwb-lock');
    var key = S.slots.filter(function (x) { return x.product; }).map(function (x) { return x.product.handle; }).sort().join(',');
    if (P.source === TOGETHER && key !== togetherKey) { togetherKey = key; setSource(TOGETHER, ''); }
    else if (!P.source && !P.query) setSource(key ? TOGETHER : (CFG.sources[0] ? CFG.sources[0].handle : 'all'), '');
    else { paintGrid(); if (visibleCount() < 8) loadMore(false); }
    setTimeout(function () { (window.innerWidth > 900 ? pSearch : pClose).focus(); }, 30);
  }
  function closePicker() {
    picker.hidden = true;
    document.documentElement.classList.remove('gwb-lock');
    var n = P.slotId && frameEls[P.slotId]; if (n) n.box.focus({ preventScroll: true });
  }
  pClose.addEventListener('click', closePicker);
  picker.addEventListener('click', function (e) { if (e.target === picker) closePicker(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) closePicker(); });

  var searchTimer = null;
  // the customer is about to search: make sure the index is on its way
  pSearch.addEventListener('focus', function () { loadIndex(); });
  pSearch.addEventListener('input', function () {
    loadIndex();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var q = pSearch.value.trim();
      if (q.length >= 2) setSource(null, q);
      else if (!q) setSource(CFG.sources[0] ? CFG.sources[0].handle : 'all', '');
    }, INDEX ? 90 : 300);
  });

  function setSource(handle, q) {
    P.source = handle; P.query = q; P.page = 0; P.pages = 1; P.items = []; P.token++;
    pEmpty.textContent = T.noResults;
    if (handle === TOGETHER) togetherKey = S.slots.filter(function (x) { return x.product; }).map(function (x) { return x.product.handle; }).sort().join(',');
    [].forEach.call(pTabs.children, function (b) { b.classList.toggle('is-active', !q && b.dataset.handle === handle); });
    pGrid.innerHTML = '';
    P.local = false; P.shown = 0;
    if (q && INDEX) {
      // the whole shop is already in the browser: answer at once, no requests
      P.local = true; P.shown = LOCAL_PAGE; P.pages = 1; P.page = 1;
      P.items = searchIndex(q);
      P.loading = false;
      paintGrid(); paintMore();
      return;
    }
    loadMore(true);
  }

  function pageUrl(n) {
    if (P.query) return ROUTE + 'search?type=product&options[prefix]=last&view=gwb&q=' + encodeURIComponent(P.query) + '&page=' + n;
    return ROUTE + 'collections/' + encodeURIComponent(P.source) + '?view=gwb&page=' + n;
  }

  // Keeps loading pages until enough posters in the right size/orientation show up.
  // "often bought together" for one poster - fetched once, and already in the
  // background when a poster is put on the wall, so the tab opens instantly
  // First choice is ARTSY Forslag (templates/product.gwb-rec): its lists are
  // written on the product every night - bought together from the shop's own
  // orders, filled up with look-alikes from the picture model. Every poster
  // remembers which list it came from (_forslag), so a sale can be counted.
  // A poster Forslag hasn't reached yet falls back to Shopify's own
  // recommendations, as before.
  var REC_CACHE = {};
  function shopifyRecs(id) {
    return fetch(ROUTE + 'recommendations/products?product_id=' + id + '&limit=10&intent=related&section_id=gwb-recommendations', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = /<script[^>]*data-gwb-rec[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
        try { return m ? JSON.parse(m[1]) : []; } catch (e) { return []; }
      });
  }
  function recsFor(prod) {
    var id = prod.id;
    if (REC_CACHE[id]) return REC_CACHE[id];
    var pr = fetchJSONRaw(ROUTE + 'products/' + encodeURIComponent(prod.handle) + '?view=gwb-rec')
      .then(function (list) {
        return (list || []).map(function (x) { var p = x.p; p._forslag = x.s; return p; });
      }, function () { return []; })
      .then(function (list) { return list.length ? list : shopifyRecs(id); });
    REC_CACHE[id] = pr;
    return pr.catch(function () { delete REC_CACHE[id]; return []; });
  }
  function prefetchRecs() {
    var n = 0;
    orderedSlots().forEach(function (s) { if (s.product && n < 4) { n++; recsFor(s.product); } });
  }

  /* ARTSY Forslag's measuring, the same way its own blocks do it
     (apps/forslag/tema-kilde/forslag.js): views and clicks per list go to
     the app through the app proxy, and a chosen poster is remembered for a
     week in the cart's hidden attribute _forslag, so the order tells Forslag
     the sale came from a suggestion. Nothing about the customer is sent. */
  var AF_MAAL = '/apps/forslag/maal', AF_KLIK = 'af_klik';
  var afMaal = { v: {}, k: {} }, afTimer = null;
  function afSend() {
    if (!Object.keys(afMaal.v).length && !Object.keys(afMaal.k).length) return;
    var data = JSON.stringify(afMaal); afMaal = { v: {}, k: {} };
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(AF_MAAL, new Blob([data], { type: 'text/plain' }));
      else fetch(AF_MAAL, { method: 'POST', body: data, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  function afSnart() { clearTimeout(afTimer); afTimer = setTimeout(afSend, 4000); }
  window.addEventListener('pagehide', afSend);
  function afVist(types) {
    try { Object.keys(types).forEach(function (t) { afMaal.v[t] = (afMaal.v[t] || 0) + 1; }); afSnart(); } catch (e) {}
  }
  function afKlik(type, pid) {
    try {
      afMaal.k[type] = (afMaal.k[type] || 0) + 1; afSnart();
      var nu = Date.now(), l = [];
      try { l = JSON.parse(localStorage.getItem(AF_KLIK) || '[]'); } catch (e) {}
      l = l.filter(function (x) { return x && x.id !== String(pid) && nu - x.t < 7 * 864e5; });
      l.unshift({ id: String(pid), type: type, t: nu });
      l = l.slice(0, 40);
      try { localStorage.setItem(AF_KLIK, JSON.stringify(l)); } catch (e) {}
      fetch(ROUTE + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _forslag: l.map(function (x) { return x.id + ':' + x.type; }).join('|') } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function loadTogether() {
    var ids = [], seen = {};
    orderedSlots().forEach(function (s) { if (s.product && !seen[s.product.id]) { seen[s.product.id] = 1; ids.push(s.product); } });
    ids = ids.slice(0, 4);
    P.page = 1; P.pages = 1;
    if (!ids.length) { P.items = []; P.loading = false; paintGrid(); pEmpty.textContent = T.togetherHint || T.noResults; pEmpty.hidden = false; pMore.hidden = true; return; }
    var tok = P.token; P.loading = true; paintMore();
    paintGrid();
    Promise.all(ids.map(recsFor)).then(function (lists) {
      if (tok !== P.token) return;
      // round-robin, so every poster on the wall gets its best matches near the top
      var out = [], used = {}, i = 0, more = true;
      while (more) {
        more = false;
        lists.forEach(function (l) { if (l[i]) { more = true; var p = l[i]; if (!used[p.handle]) { used[p.handle] = 1; PRODUCTS[p.handle] = PRODUCTS[p.handle] || p; out.push(p); } } });
        i++;
      }
      P.items = out; P.loading = false;
      pEmpty.textContent = T.noResults;
      paintGrid(); paintMore();
      // one view per list that is actually shown in this frame's size
      var shown = {};
      fitting().forEach(function (p) { if (p._forslag) shown[p._forslag] = 1; });
      afVist(shown);
    });
  }

  function loadMore(first) {
    if (P.source === TOGETHER && !P.query) { loadTogether(); return; }
    if (P.local) { paintMore(); return; }
    if (P.loading || P.page >= P.pages) { paintMore(); return; }
    P.loading = true; paintMore();
    var tok = P.token;
    var want = visibleCount() + 12;
    (function next() {
      if (P.page >= P.pages) return Promise.resolve();
      var pr = fetchJSON(pageUrl(P.page + 1));
      // fetch the page after in parallel, so filtered sizes fill up faster
      if (P.page + 2 <= P.pages && P.page + 2 <= 12) fetchJSON(pageUrl(P.page + 2)).catch(function () {});
      return pr.then(function (d) {
        if (tok !== P.token) return;
        P.page = d.page || (P.page + 1); P.pages = d.pages || P.page;
        (d.products || []).forEach(function (p) { PRODUCTS[p.handle] = PRODUCTS[p.handle] || p; P.items.push(p); });
        paintGrid();
        if (visibleCount() < want && P.page < P.pages && P.page < 12) return next();
      });
    })().catch(function () {}).then(function () {
      if (tok !== P.token) return;
      P.loading = false; paintGrid(); paintMore();
      if (first) borderCache = {};
      paintStage();
    });
  }
  pMore.addEventListener('click', function () {
    if (P.local) { P.shown += LOCAL_PAGE; paintGrid(); return; }
    loadMore(false);
  });

  function fitting() {
    var s = slotById(P.slotId); if (!s) return [];
    var seen = {};
    return P.items.filter(function (p) { if (seen[p.handle]) return false; seen[p.handle] = 1; return posterFits(p, s); });
  }
  function visibleCount() { return fitting().length; }
  function paintMore() {
    pMore.hidden = P.local ? fitting().length <= P.shown : !(P.page < P.pages);
    pMore.disabled = P.loading;
    pMore.textContent = P.loading ? '…' : T.loadMore;
    pEmpty.hidden = P.loading || fitting().length > 0;
  }

  function paintGrid() {
    var s = slotById(P.slotId); if (!s) return;
    pGrid.innerHTML = '';
    var list = fitting();
    if (P.local) list = list.slice(0, P.shown);
    if (P.loading && !list.length) {
      // grey placeholders while the posters load, so it doesn't look empty
      for (var k = 0; k < 6; k++) { var sk = el('span', 'gwb-card gwb-card--skel'); sk.appendChild(el('span', 'gwb-card__media')); sk.appendChild(el('span', 'gwb-card__name', ' ')); pGrid.appendChild(sk); }
    }
    list.forEach(function (p) {
      var v = p.v.filter(function (x) { return normSize(x.size) === s.s; })[0];
      var used = onWall(p.handle, s.id);
      var card = el('button', 'gwb-card'); card.type = 'button';
      if (used) { card.disabled = true; card.classList.add('is-used'); }
      if (s.product && s.product.handle === p.handle) card.classList.add('is-current');
      var media = el('span', 'gwb-card__media');
      var im = el('img'); im.src = p.thumb; im.alt = ''; im.loading = 'lazy';
      media.appendChild(im);
      if (used) media.appendChild(el('span', 'gwb-card__badge', T.onWall));
      card.appendChild(media);
      card.appendChild(el('span', 'gwb-card__name', p.title));
      var pr = el('span', 'gwb-card__price', money(v.price));
      if (v.compare > v.price) { pr.appendChild(document.createTextNode(' ')); pr.appendChild(el('s', null, money(v.compare))); }
      card.appendChild(pr);
      card.addEventListener('click', function () { choose(p, card); });
      pGrid.appendChild(card);
    });
    paintMore();
  }

  function choose(p, card) {
    var s = slotById(P.slotId); if (!s) return;
    if (onWall(p.handle, s.id)) return;
    if (p.lean) {
      // from the search index: sizes and prices only. The frames come with
      // the full poster (?view=gwb), usually within a fraction of a second.
      if (card) card.classList.add('is-loading');
      var slotId = P.slotId;
      loadProduct(p.handle).then(function (full) {
        if (card) card.classList.remove('is-loading');
        if (P.slotId !== slotId || picker.hidden) return;
        choose(full);
      }).catch(function () { if (card) card.classList.remove('is-loading'); });
      return;
    }
    if (P.source === TOGETHER && !P.query && p._forslag) afKlik(p._forslag, p.id);
    s.product = p;
    begyndt(); track('poster');
    setTimeout(prefetchRecs, 600);
    borderCache = {};
    // Back to the wall after every poster, so the customer sees it hanging
    // and taps the next frame themselves (auto-advancing to the next empty
    // frame confused people - Martin 27 Sep 2026).
    S.selected = null;
    closePicker();
    if (S.slots.every(function (x) { return x.product; })) S.step = 4;
    if (window.innerWidth < 900) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    render(); save();
  }

  /* ------------------------------------------------------------ go */

  function render() { paintStage(); paintPanel(); }

  var ro = window.ResizeObserver ? new ResizeObserver(function () { paintStage(); }) : null;
  if (ro) ro.observe(stage); else window.addEventListener('resize', paintStage);
  roomImg.addEventListener('load', paintStage);

  // Opened from a product page (?poster=<handle>): start a wall with that
  // poster already hanging in the biggest frame it fits. The room the
  // customer used last time is kept.
  function layoutByName(n) { return CFG.layouts.filter(function (l) { return l.name === n; })[0]; }
  function startWithPoster(handle, saved) {
    if (saved && saved.r) {
      var r = String(saved.r);
      S.room = r.indexOf('c:') === 0 ? { kind: 'wall', id: r.slice(2) } : { kind: 'photo', id: r };
    }
    // A wall in progress: put the poster in its first empty frame that fits
    // (or just show the wall if the poster already hangs there).
    var tryExisting = (saved && saved.s && saved.s.length) ? restore(saved).then(function () {
      return loadProduct(handle).then(function (p) {
        if (onWall(p.handle, null)) return true;
        var free = orderedSlots().filter(function (sl) { return !sl.product && posterFits(p, sl); })[0];
        if (free) { free.product = p; return true; }
        // no free frame fits: hang it in a new frame next to the wall, never throw the wall away
        var o = orient(p.ratio);
        if (o === 'q') return false;
        var sizes = p.v.map(function (v) { return normSize(v.size); }).filter(function (x) { return SIZES.indexOf(x) >= 0; });
        if (!sizes.length) return false;
        var slot = { id: uid(), s: sizes.indexOf('50x70') >= 0 ? '50x70' : sizes[sizes.length - 1], o: o, x: 0, y: 0, product: p, frame: null };
        placeFree(slot);
        S.slots.push(slot);
        return true;
      });
    }) : Promise.resolve(false);
    return tryExisting.catch(function () { return false; }).then(function (done) {
      if (done) { S.step = S.slots.every(function (x) { return x.product; }) ? 4 : 3; return null; }
      return startFresh(handle);
    }).then(function () {
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      render(); save();
    });
  }
  function startFresh(handle) {
    return loadProduct(handle).then(function (p) {
      var o = orient(p.ratio);
      var layout = (o === 'l' ? layoutByName('Landscape feature') : layoutByName('Centre stage')) || CFG.layouts[0];
      applyLayout(layout);
      S.slots.forEach(function (sl) { sl.product = null; });
      var fits = S.slots.filter(function (sl) { return posterFits(p, sl); })
        .sort(function (a, b) { var da = dims(a.s, a.o), db = dims(b.s, b.o); return db.w * db.h - da.w * da.h; });
      if (fits.length) fits[0].product = p;
      else if (o !== 'q') {
        // none of the layout's sizes exist for this poster: hang it alone in its biggest size
        var sizes = p.v.map(function (v) { return normSize(v.size); }).filter(function (x) { return SIZES.indexOf(x) >= 0; });
        if (sizes.length) {
          S.slots = [{ id: uid(), s: sizes[sizes.length - 1], o: o === 'l' ? 'l' : 'p', x: 0, y: 0, product: p, frame: null }];
          fitToRoom();
        }
      }
      S.step = 3;
    }).catch(function () {
      applyLayout(CFG.layouts[3] || CFG.layouts[0]);
    });
  }

  function boot() {
    var fromHash = null, fromStore = null;
    var posterParam = null;
    try { posterParam = new URLSearchParams(location.search).get('poster'); } catch (e) {}
    track('view', { l: (window.Shopify && Shopify.locale) || '', p: posterParam ? 1 : 0 });
    var m = /[#&]w=([A-Za-z0-9_-]+)/.exec(location.hash || '');
    if (m) { try { fromHash = decode(m[1]); } catch (e) {} }
    if (!fromHash) { try { fromStore = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) {} }
    var saved = fromHash || fromStore;
    if (posterParam && !fromHash) {
      applyLayout(CFG.layouts[3] || CFG.layouts[0]);
      render();
      startWithPoster(posterParam, saved);
    } else if (saved && saved.s && saved.s.length) {
      restore(saved).then(function () {
        S.step = S.slots.every(function (s) { return s.product; }) ? 4 : (S.slots.some(function (s) { return s.product; }) ? 3 : 1);
        render();
      });
      render();
    } else {
      applyLayout(CFG.layouts[3] || CFG.layouts[0]);
      render();
    }
    // preload the first source so frame images are known and the picker opens
    // instantly - but only once the room photo is in, so it doesn't compete with it
    var preloaded = false;
    function preload() {
      if (preloaded) return; preloaded = true;
      fetchJSON(ROUTE + 'collections/' + encodeURIComponent(CFG.sources[0] ? CFG.sources[0].handle : 'all') + '?view=gwb&page=1')
      .then(function (d) { (d.products || []).forEach(function (p) { PRODUCTS[p.handle] = PRODUCTS[p.handle] || p; }); borderCache = {}; paintStage(); prefetchRecs(); })
      .catch(function () {})
      // then the search index, quietly, so the search answers at once when it's used
      .then(function () { setTimeout(loadIndex, 1500); });
    }
    if (roomImg.hidden || roomImg.complete) setTimeout(preload, 300);
    else { roomImg.addEventListener('load', function () { setTimeout(preload, 300); }, { once: true }); roomImg.addEventListener('error', preload, { once: true }); }
    setTimeout(preload, 4000);
  }
  boot();
})();
